<template>
  <div class="login-page">
    <!-- 加载中遮罩 -->
    <div v-if="checking" class="checking-overlay">
      <div class="checking-content">
        <van-loading size="40px" color="#d51900">加载中...</van-loading>
      </div>
    </div>

    <!-- 登录页面内容 -->
    <div v-show="!checking" class="login-content">
      <!-- 顶部品牌区域 -->
      <div class="brand-section">
      <div class="brand-decoration">
        <div class="deco-circle deco-circle-1"></div>
        <div class="deco-circle deco-circle-2"></div>
        <div class="deco-circle deco-circle-3"></div>
      </div>
      <div class="brand-content">
        <div class="brand-logo">
          <svg class="jj-logo" viewBox="0 0 216 30" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M45.3061 20.8646C43.775 20.8646 42.9213 19.4147 42.9213 16.7914C42.9213 14.1274 43.775 12.7182 45.3061 12.7182C46.8373 12.7182 47.691 14.1491 47.691 16.7914C47.6883 19.4553 46.8346 20.8646 45.3061 20.8646ZM45.3061 11.6261C42.1869 11.6261 40.4579 13.9513 40.4579 16.7914C40.4579 19.6315 42.1869 21.9567 45.3061 21.9567C48.4254 21.9567 50.1544 19.6315 50.1544 16.7914C50.1544 13.9513 48.4254 11.6261 45.3061 11.6261ZM66.9809 11.6261C65.5094 11.6261 64.6964 12.2629 64.2384 13.0759H64.1191V11.8239H61.775V21.7589H64.1191V15.3415C64.1191 13.8727 64.8752 13.0163 66.0866 13.0163C67.2601 13.0163 67.775 13.7914 67.775 14.9648V21.7589H70.1191V14.9431C70.1219 12.8971 69.0487 11.6261 66.9809 11.6261ZM75.4444 11.6261C73.279 11.6261 71.6503 12.5394 71.6503 14.4879C71.6503 16.1383 72.7831 17.0326 74.0541 17.3497L76.0406 17.8456C77.0948 18.103 77.5717 18.4824 77.5717 19.3171C77.5717 20.3307 76.8563 20.9079 75.6042 20.9079C74.2519 20.9079 73.5582 20.2521 73.3387 18.6044L71.233 19.2006C71.3522 20.9106 72.943 21.9621 75.3468 21.9621C78.0297 21.9621 79.4796 20.7101 79.4796 18.7236C79.4796 16.8564 78.1869 16.0814 76.8373 15.7426L74.9294 15.2656C73.9755 15.0272 73.5582 14.5908 73.5582 13.954C73.5582 13.1599 74.233 12.683 75.2465 12.683C76.4389 12.683 77.1733 13.3388 77.2736 14.5908L79.2601 13.9946C79.0216 12.599 77.6503 11.6261 75.4444 11.6261ZM85.3007 20.8646C83.7696 20.8646 82.9159 19.4147 82.9159 16.7914C82.9159 14.1274 83.7696 12.7182 85.3007 12.7182C86.8319 12.7182 87.6855 14.1491 87.6855 16.7914C87.6855 19.4553 86.8292 20.8646 85.3007 20.8646ZM85.3007 11.6261C82.1815 11.6261 80.4525 13.9513 80.4525 16.7914C80.4525 19.6315 82.1815 21.9567 85.3007 21.9567C88.42 21.9567 90.149 19.6315 90.149 16.7914C90.149 13.9513 88.42 11.6261 85.3007 11.6261ZM96.7452 11.6261C95.2736 11.6261 94.4606 12.2629 94.0026 13.0759H93.8834V11.8239H91.5392V21.7589H93.8834V15.3415C93.8834 13.8727 94.6395 13.0163 95.8509 13.0163C97.0243 13.0163 97.5392 13.7914 97.5392 14.9648V21.7589H99.8834V14.9431C99.8834 12.8971 98.8102 11.6261 96.7452 11.6261ZM131.574 20.8646C130.043 20.8646 129.19 19.4147 129.19 16.7914C129.19 14.1274 130.043 12.7182 131.574 12.7182C133.106 12.7182 133.959 14.1491 133.959 16.7914C133.959 19.4553 133.103 20.8646 131.574 20.8646ZM131.574 11.6261C128.455 11.6261 126.726 13.9513 126.726 16.7914C126.726 19.6315 128.455 21.9567 131.574 21.9567C134.694 21.9567 136.423 19.6315 136.423 16.7914C136.423 13.9513 134.694 11.6261 131.574 11.6261ZM153.249 11.6261C151.778 11.6261 150.965 12.2629 150.507 13.0759H150.387V11.8239H148.043V21.7589H150.387V15.3415C150.387 13.8727 151.144 13.0163 152.355 13.0163C153.528 13.0163 154.043 13.7914 154.043 14.9648V21.7589H156.387V14.9431C156.39 12.8971 155.317 11.6261 153.249 11.6261ZM161.715 11.6261C159.55 11.6261 157.921 12.5394 157.921 14.4879C157.921 16.1383 159.054 17.0326 160.325 17.3497L162.312 17.8456C163.366 18.103 163.843 18.4824 163.843 19.3171C163.843 20.3307 163.127 20.9079 161.875 20.9079C160.523 20.9079 159.829 20.2521 159.61 18.6044L157.504 19.2006C157.623 20.9106 159.214 21.9621 161.618 21.9621C164.301 21.9621 165.751 20.7101 165.751 18.7236C165.751 16.8564 164.458 16.0814 163.108 15.7426L161.2 15.2656C160.247 15.0272 159.829 14.5908 159.829 13.954C159.829 13.1599 160.504 12.683 161.518 12.683C162.71 12.683 163.444 13.3388 163.545 14.5908L165.531 13.9946C165.29 12.599 163.919 11.6261 161.715 11.6261ZM171.569 20.8646C170.038 20.8646 169.184 19.4147 169.184 16.7914C169.184 14.1274 170.038 12.7182 171.569 12.7182C173.1 12.7182 173.954 14.1491 173.954 16.7914C173.954 19.4553 173.097 20.8646 171.569 20.8646ZM171.569 11.6261C168.45 11.6261 166.721 13.9513 166.721 16.7914C166.721 19.6315 168.45 21.9567 171.569 21.9567C174.688 21.9567 176.417 19.6315 176.417 16.7914C176.417 13.9513 174.688 11.6261 171.569 11.6261ZM183.013 11.6261C181.542 11.6261 180.729 12.2629 180.271 13.0759H180.152V11.8239H177.807V21.7589H180.152V15.3415C180.152 13.8727 180.908 13.0163 182.119 13.0163C183.293 13.0163 183.807 13.7914 183.807 14.9648V21.7589H186.152V14.9431C186.152 12.8971 185.078 11.6261 183.013 11.6261ZM39.0677 7.85101H36.6042V18.122C36.6042 19.7914 35.9674 20.7833 34.4579 20.7833C32.9674 20.7833 32.3116 19.7291 32.3116 17.9215V16.0136L29.8481 16.6288V17.4824C29.8481 20.0841 31.1408 22.0732 34.4579 22.0732C37.775 22.0732 39.0677 20.0868 39.0677 17.4824V7.85101ZM53.8888 7.85101H51.5446V21.7589H53.8888V15.3415C53.8888 13.8727 54.6449 13.0163 55.8563 13.0163C57.0297 13.0163 57.5446 13.7914 57.5446 14.9648V21.7589H59.8888V14.9431C59.8888 12.8971 58.8156 11.6261 56.7506 11.6261C55.279 11.6261 54.466 12.2629 54.008 13.0759H53.8888V7.85101ZM125.336 7.85101H122.873V18.122C122.873 19.7914 122.236 20.7833 120.726 20.7833C119.236 20.7833 118.58 19.7291 118.58 17.9215V16.0136L116.116 16.6288V17.4824C116.116 20.0841 117.409 22.0732 120.726 22.0732C124.043 22.0732 125.336 20.0868 125.336 17.4824V7.85101ZM140.157 7.85101H137.813V21.7589H140.157V15.3415C140.157 13.8727 140.913 13.0163 142.125 13.0163C143.298 13.0163 143.813 13.7914 143.813 14.9648V21.7589H146.157V14.9431C146.157 12.8971 145.084 11.6261 143.019 11.6261C141.547 11.6261 140.734 12.2629 140.276 13.0759H140.157V7.85101ZM107.612 20.6261C105.705 20.6261 104.534 19.0759 104.534 17.4282C104.534 16.3957 104.992 15.4418 105.745 14.9052L110.236 19.8131C109.401 20.309 108.466 20.6261 107.612 20.6261ZM111.984 18.1816L108.089 13.8889C108.786 13.6098 109.461 13.5123 110.016 13.5123C111.626 13.5123 112.618 14.4472 112.618 16.057C112.621 16.7724 112.42 17.5068 111.984 18.1816ZM107.553 13.3144L106.699 12.3605C105.943 11.5258 105.726 11.0082 105.726 10.393C105.726 9.24125 106.461 8.58543 107.612 8.58543C108.786 8.58543 109.48 9.26022 109.48 10.4933C109.48 11.6261 108.924 12.6992 107.553 13.3144ZM107.672 7.53394C104.929 7.53394 103.58 9.0651 103.58 10.9702C103.58 12.0028 104.016 13.038 105.171 14.2873L105.19 14.328C103.244 15.2629 102.35 16.7724 102.35 18.3226C102.35 20.3686 103.919 22.0787 106.344 22.0787C107.734 22.0787 109.363 21.5014 110.835 20.4689L112.027 21.7616H115.146V21.6613L112.604 18.8591C113.677 17.5881 114.293 16.1979 114.293 14.9838C114.293 13.4743 113.279 12.4608 111.691 12.4608C110.856 12.4608 109.921 12.6992 109.306 12.9377L109.266 12.8591C110.775 12.0434 111.412 11.29 111.412 10.2358C111.406 8.72635 110.057 7.53394 107.672 7.53394Z" fill="white"/>
          </svg>
        </div>
        <h1 class="brand-title">Acuvue iLearn</h1>
        <p class="brand-slogan">专业视光培训 · 助力职业成长</p>
      </div>
    </div>

    <!-- 登录表单卡片 -->
    <div class="login-form-container">
      <div class="form-card">
        <div class="form-header">
          <h2 class="form-title">欢迎回来</h2>
          <p class="form-subtitle">请登录您的账号</p>
        </div>

        <van-form @submit="onSubmit" class="login-form">
          <div class="input-group">
            <label class="input-label">手机号</label>
            <van-field
              v-model="userphone"
              name="phone"
              type="tel"
              clearable
              placeholder="请输入手机号"
              maxlength="11"
              class="custom-input"
            />
          </div>

          <div class="input-group">
            <label class="input-label">验证码</label>
            <div class="code-input-wrapper">
              <van-field
                v-model="password"
                type="digit"
                name="code"
                placeholder="请输入6位验证码"
                maxlength="6"
                clearable
                class="custom-input code-input"
              />
              <span 
                class="get-code-btn" 
                :class="{ 'get-code-disabled': disabled }" 
                @click="sendCode"
              >
                {{ codeMsg }}
              </span>
            </div>
          </div>

          <van-button class="submit-btn" round block native-type="submit">
            立即登录
          </van-button>

          <div class="register-link">
            <span>还没有账号？</span>
            <router-link to="/register" class="link">立即注册</router-link>
          </div>
        </van-form>

        <div class="form-footer">
          <p class="agreement-text">
            登录即表示同意
            <router-link to="/policy?view=true" class="link">《用户协议》</router-link>
            和
            <router-link to="/policy?view=true" class="link">《隐私政策》</router-link>
          </p>
        </div>
      </div>
    </div>
    </div><!-- 关闭 login-content -->
  </div>
</template>

<script>
import { Field, Form, Button, Toast } from "vant";
import {
  Member_send_message,
  Member_CheckMessage,
  GetH5LoginJwtToken_JWTToken3,
  Member_QueryMember
} from "./api/api";

export default {
  name: "login",
  components: {
    [Field.name]: Field,
    [Form.name]: Form,
    [Button.name]: Button,
  },
  data() {
    return {
      checking: true,
      userphone: "",
      password: "",
      disabled: false,
      codeMsg: "获取验证码",
      timer: null,
    };
  },
  async mounted() {
    this.checking = true;

    // 从 URL 获取 openid
    if (this.getQueryString("openid")) {
      localStorage.setItem("openid", this.getQueryString("openid"));
    }

    // 检查 openid，没有则跳转微信授权
    const openid = localStorage.getItem("openid");
    if (!openid || openid === "null" || openid === "undefined") {
      location.href = `https://plusapi.51i.cc/api/Oauth2/authorize?redirect_uri=${encodeURIComponent(location.href)}`;
      return;
    }

    // 检查 token
    const token = localStorage.getItem("token");
    if (!token || token === "null" || token === "undefined") {
      // 未登录，检查是否需要跳转 policy
      const policyIf = this.getQueryString("policy_if");
      const policyAgreed = localStorage.getItem("policyAgreed");
      const link = this.getQueryString("link");

      if (policyIf === "y" || policyAgreed === "true") {
        // 已同意协议，留在登录页或跳转 link
        if (link) {
          this.$router.push({ path: link });
        } else {
          // 显示登录表单
          this.checking = false;
        }
      } else {
        // 未同意协议，跳转 policy
        this.$router.push({ path: link ? `/policy?link=${link}` : "/policy" });
      }
    } else {
      // 已有 token，验证用户状态
      try {
        const { data } = await Member_QueryMember();
        if (data.status === 200) {
          this.$router.push({ path: "/home" });
        } else {
          // token 无效，清除并显示登录表单
          localStorage.removeItem("token");
          this.checking = false;
        }
      } catch (e) {
        // token 无效，清除并显示登录表单
        localStorage.removeItem("token");
        this.checking = false;
      }
    }
  },
  methods: {
    getQueryString(name) {
      const regex = new RegExp("[?|&]" + name + "=([^&;]+?)(&|#|;|$)");
      const result = regex.exec(location.href) || ["", ""];
      return decodeURIComponent(result[1].replace(/\+/g, "%20")) || null;
    },
    async GetH5LoginJwtToken_JWTToken3() {
      const { data } = await GetH5LoginJwtToken_JWTToken3();
      this.$store.commit("saveToken", data.response.token);
    },
    async sendCode() {
      if (!this.userphone) {
        Toast("请输入手机号");
        return;
      }
      if (!/^1[3-9]\d{9}$/.test(this.userphone)) {
        Toast("请输入正确的手机号");
        return;
      }

      this.disabled = true;
      let countdown = 60;
      this.codeMsg = `${countdown}s`;

      this.timer = setInterval(() => {
        countdown--;
        if (countdown <= 0) {
          clearInterval(this.timer);
          this.disabled = false;
          this.codeMsg = "获取验证码";
        } else {
          this.codeMsg = `${countdown}s`;
        }
      }, 1000);

      try {
        const { data } = await Member_send_message({ Phone: this.userphone });
        if (data.status === 200) {
          Toast.success("验证码已发送");
        } else {
          Toast.fail(data.msg || "发送失败");
          clearInterval(this.timer);
          this.disabled = false;
          this.codeMsg = "获取验证码";
        }
      } catch (e) {
        Toast.fail("发送失败，请重试");
        clearInterval(this.timer);
        this.disabled = false;
        this.codeMsg = "获取验证码";
      }
    },
    async onSubmit() {
      if (!this.userphone) {
        Toast("请输入手机号");
        return;
      }
      if (this.password.length < 6) {
        Toast("请输入验证码");
        return;
      }

      Toast.loading({ message: "登录中...", forbidClick: true });

      try {
        const { data } = await Member_CheckMessage({
          Phone: this.userphone,
          Code: this.password,
        });

        Toast.clear();

        if (data.status === 200) {
          await this.GetH5LoginJwtToken_JWTToken3();
          this.$router.push({ path: "/home" });
        } else {
          this.$dialog({
            message: data.msg,
            confirmButtonColor: "#d51900",
          });
        }
      } catch (e) {
        Toast.clear();
        Toast.fail("登录失败，请重试");
      }
    },
  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer);
    }
  },
};
</script>

<style scoped>
/* 主题色变量 */
:root {
  --primary-color: #d51900;
  --primary-dark: #b01500;
  --primary-light: #ff3b2f;
}

/* 加载中遮罩 */
.checking-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: #f5f7fa;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

.checking-content {
  text-align: center;
}

.login-page {
  min-height: 100vh;
  min-height: calc(100vh - env(safe-area-inset-top) - env(safe-area-inset-bottom));
  min-height: -webkit-fill-available;
  background: #f5f7fa;
  display: flex;
  flex-direction: column;
  padding-top: env(safe-area-inset-top);
  padding-bottom: env(safe-area-inset-bottom);
  padding-left: env(safe-area-inset-left);
  padding-right: env(safe-area-inset-right);
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}

/* 品牌区域 */
.brand-section {
  background: linear-gradient(135deg, #d51900 0%, #b01500 50%, #8a1000 100%);
  padding: 50px 20px 80px;
  position: relative;
  overflow: hidden;
}

.brand-decoration {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  pointer-events: none;
}

.deco-circle {
  position: absolute;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.08);
}

.deco-circle-1 {
  width: 200px;
  height: 200px;
  top: -80px;
  right: -60px;
}

.deco-circle-2 {
  width: 120px;
  height: 120px;
  top: 30%;
  left: -40px;
}

.deco-circle-3 {
  width: 80px;
  height: 80px;
  bottom: 20px;
  right: 15%;
}

.brand-content {
  position: relative;
  z-index: 1;
  text-align: center;
}

.brand-logo {
  margin-bottom: 20px;
}

.jj-logo {
  width: 180px;
  height: auto;
}

.brand-title {
  font-size: 24px;
  font-weight: 700;
  color: #fff;
  margin: 0 0 8px;
  letter-spacing: 2px;
}

.brand-slogan {
  font-size: 13px;
  color: rgba(255, 255, 255, 0.9);
  margin: 0;
  letter-spacing: 1px;
}

/* 表单容器 */
.login-form-container {
  flex: 1;
  margin-top: -40px;
  padding: 0 16px 24px;
  position: relative;
  z-index: 10;
}

.form-card {
  background: #fff;
  border-radius: 20px;
  padding: 28px 20px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.08);
  max-width: 400px;
  margin: 0 auto;
}

.form-header {
  text-align: center;
  margin-bottom: 28px;
}

.form-title {
  font-size: 22px;
  font-weight: 700;
  color: #1a1a1a;
  margin: 0 0 6px;
}

.form-subtitle {
  font-size: 14px;
  color: #888;
  margin: 0;
}

/* 输入框组 */
.input-group {
  margin-bottom: 20px;
}

.input-label {
  display: block;
  font-size: 14px;
  font-weight: 600;
  color: #333;
  margin-bottom: 8px;
}

.custom-input {
  background: transparent;
  padding: 0;
}

.custom-input >>> .van-cell {
  padding: 12px 0;
  background: transparent;
}

.custom-input >>> .van-field__body {
  border-bottom: 1px solid #e5e5e5;
  padding-bottom: 10px;
  transition: border-color 0.25s ease;
}

.custom-input >>> .van-field__body:focus-within {
  border-bottom-color: #d51900;
}

.custom-input >>> .van-field__control {
  font-size: 16px;
  color: #1a1a1a;
}

.custom-input >>> .van-field__control::placeholder {
  color: #bbb;
  font-size: 15px;
}

/* 验证码输入框 */
.code-input-wrapper {
  display: flex;
  align-items: flex-end;
  gap: 12px;
}

.code-input {
  flex: 1;
}

.get-code-btn {
  flex-shrink: 0;
  padding: 10px 0;
  font-size: 14px;
  font-weight: 600;
  color: #d51900;
  cursor: pointer;
  white-space: nowrap;
  border-bottom: 1px solid transparent;
  -webkit-tap-highlight-color: transparent;
}

.get-code-disabled {
  color: #bbb;
  pointer-events: none;
}

/* 登录按钮 */
.submit-btn {
  height: 50px;
  font-size: 17px;
  font-weight: 600;
  letter-spacing: 2px;
  margin-top: 20px;
  background: linear-gradient(135deg, #d51900 0%, #ff3b2f 100%);
  border: none;
  color: #fff;
  box-shadow: 0 6px 20px rgba(213, 25, 0, 0.3);
  transition: all 0.25s ease;
}

.submit-btn:active {
  transform: scale(0.98);
  box-shadow: 0 3px 10px rgba(213, 25, 0, 0.3);
}

/* 注册链接 */
.register-link {
  text-align: center;
  margin-top: 20px;
  font-size: 14px;
  color: #888;
}

.register-link .link {
  color: #d51900;
  font-weight: 600;
  text-decoration: none;
  margin-left: 4px;
}

/* 底部协议 */
.form-footer {
  margin-top: 20px;
  text-align: center;
}

.agreement-text {
  font-size: 12px;
  color: #aaa;
  margin: 0;
  line-height: 1.8;
}

.agreement-text .link {
  color: #d51900;
  text-decoration: none;
}

/* 移动端适配 */
@media screen and (max-width: 375px) {
  .brand-section {
    padding: 40px 16px 70px;
  }
  
  .brand-title {
    font-size: 22px;
  }
  
  .form-card {
    padding: 24px 16px;
  }
  
  .form-title {
    font-size: 20px;
  }
}

/* 小屏幕高度适配 (iPhone 14 等) */
@media screen and (max-height: 750px) {
  .brand-section {
    padding: 35px 16px 60px;
  }
  
  .jj-logo {
    width: 150px;
  }
  
  .brand-logo {
    margin-bottom: 14px;
  }
  
  .brand-title {
    font-size: 20px;
    margin-bottom: 4px;
  }
  
  .brand-slogan {
    font-size: 12px;
  }
  
  .login-form-container {
    margin-top: -35px;
    padding-bottom: 16px;
  }
  
  .form-card {
    padding: 22px 18px;
  }
  
  .form-header {
    margin-bottom: 20px;
  }
  
  .form-title {
    font-size: 20px;
  }
  
  .input-group {
    margin-bottom: 16px;
  }
  
  .submit-btn {
    height: 46px;
    margin-top: 16px;
  }
  
  .register-link {
    margin-top: 16px;
  }
  
  .form-footer {
    margin-top: 16px;
  }
}

/* 更小屏幕 (iPhone SE 等) */
@media screen and (max-height: 667px) {
  .brand-section {
    padding: 25px 16px 50px;
  }
  
  .jj-logo {
    width: 130px;
  }
  
  .brand-logo {
    margin-bottom: 10px;
  }
  
  .brand-title {
    font-size: 18px;
  }
  
  .login-form-container {
    margin-top: -30px;
  }
  
  .form-card {
    padding: 18px 16px;
  }
  
  .form-header {
    margin-bottom: 16px;
  }
  
  .form-title {
    font-size: 18px;
  }
  
  .input-group {
    margin-bottom: 14px;
  }
  
  .submit-btn {
    height: 44px;
    font-size: 16px;
    margin-top: 14px;
  }
  
  .register-link,
  .form-footer {
    margin-top: 14px;
  }
}

/* Android 状态栏适配 */
@supports (padding-top: constant(safe-area-inset-top)) {
  .login-page {
    padding-top: constant(safe-area-inset-top);
    padding-bottom: constant(safe-area-inset-bottom);
  }
}
</style>



// WEBPACK FOOTER //
// src/login.vue